import React from "react";
import { useSelector } from "react-redux";
import {
    selectAllRegistration,
    updatePromoCodes,
    updatePromoDiscounts,
} from "../../../../../redux/slices/registrationSlice";
import { selectSpecificFormSetting } from "../../../../../redux/slices/formSettingsSlice";
import UpdatePromoCodes from "./UpdatePromoCodes";

const ConnectedUpdatePromoCodes = () => {
    const { registrations = [], promoCodes = [] } = useSelector(
        selectAllRegistration,
    );
    const formId = useSelector((state) =>
        selectSpecificFormSetting(state, "id"),
    );
    const participantsCategory = [];
    const getParticipantCategories = (registrations) => {
        if (registrations[0] && Object.keys(registrations[0]).length > 0) {
            registrations.map((participant) => {
                let categoryId;

                if (
                    participant &&
                    participant.Category &&
                    participant.Category[0]
                ) {
                    categoryId = participant.Category[0];
                }

                if (participant && participant.Category) {
                    participantsCategory.push({ CategoryId: categoryId });
                }
            });
            return participantsCategory;
        }
    };

    const submitValues = {
        promoCodes,
        participants: getParticipantCategories(registrations),
    };

    const updatePromoCodesProps = {
        formId,
        promoCodes,
        registrations,
        submitValues,
        updatePromoCodes,
        updatePromoDiscounts,
    };

    return <UpdatePromoCodes {...updatePromoCodesProps} />;
};

export default ConnectedUpdatePromoCodes;
